export enum ContainerStatus {
  Available = 'AVAILABLE',
  Assigned = 'ASSIGNED',
  Weighted = 'WEIGHED',
  AwaitingWeighing = 'AWAITING_WEIGHING',
}

export interface Container {
  uuid?: string
  readonly code: string
  readonly typeUuid: string
  roomUuid: string
  status: ContainerStatus
}
